import cookieHandler from "AtomicUtils/cookieHandler"

export const gtmEventTypes = {
  WAIT_MAZDA: "WAIT_MAZDA",
  OWN_MAZDA: "OWN_MAZDA",
  DONT_OWN_MAZDA: "DONT_OWN_MAZDA",
  NEXT_STEP: "NEXT_STEP",
  STEP_GO_BACK: "STEP_GO_BACK",
  ENTER_EMAIL: "FED-MYMAZDA_ENTER_EMAIL",
  ENTER_PASSWORD: "ENTER_PASSWORD",
  REGISTER: "REGISTER"
}

export const gtmEvents = {
  [gtmEventTypes.WAIT_MAZDA]: () => ({
    type: gtmEventTypes.WAIT_MAZDA,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.WAIT_MAZDA,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Waiting on a mazda"
  }),
  [gtmEventTypes.OWN_MAZDA]: () => ({
    type: gtmEventTypes.OWN_MAZDA,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.OWN_MAZDA,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Own mazda"
  }),
  [gtmEventTypes.DONT_OWN_MAZDA]: () => ({
    type: gtmEventTypes.DONT_OWN_MAZDA,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.DONT_OWN_MAZDA,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Don't Own mazda"
  }),
  [gtmEventTypes.NEXT_STEP]: () => ({
    type: gtmEventTypes.NEXT_STEP,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.NEXT_STEP,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Next step"
  }),
  [gtmEventTypes.STEP_GO_BACK]: () => ({
    type: gtmEventTypes.STEP_GO_BACK,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.STEP_GO_BACK,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Go back a step"
  }),
  [gtmEventTypes.ENTER_EMAIL]: () => ({
    type: gtmEventTypes.ENTER_EMAIL,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_EMAIL,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Entered \"EMAIL\""
  }),
  [gtmEventTypes.ENTER_PASSWORD]: () => ({
    type: gtmEventTypes.ENTER_PASSWORD,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.ENTER_PASSWORD,
    pageCategory: "MyMazda Create password Form",
    pageAction: "MyMazda Register Form - Entered \"Password\""
  }),
  [gtmEventTypes.REGISTER]: () => ({
    type: gtmEventTypes.REGISTER,
    event: "reactjs.event",
    userId: new cookieHandler().getCookie("userId"),
    eventID: gtmEventTypes.REGISTER,
    pageCategory: "MyMazda Register Form",
    pageAction: "MyMazda Register Form - Register"
  })
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/mymazda-register-duck.js